// В.2.d-2: Лабораторная крыса (liv_laboratornaya_krysa, rare, 1/1/1, stealth).
// Триггер «в конце хода»:
//   1. applyPermanentBuff(self, +1/0/1, source=cardId).
//      По правилу проекта +1 hp = +1 max_hp + синхронный +1 current_hp.
//   2. summonUnit('liv_laboratornaya_krysa', своя сторона, случайный свободный).
//      Призванная копия — свежий инстанс с base 1/1/1 и stealth.
//      Если свободного слота нет — призыв пропускается, +1/0/1 у оригинала
//      остаётся.
//
// Защита от каскада: snapshot в runOnEndOfTurnTriggers фиксирует поле в
// момент входа в EOT — призванная копия НЕ попадает в текущий проход и
// триггерит только на СЛЕДУЮЩЕМ EOT. См. eot-triggers.js.
//
// Молчание блокирует ВЕСЬ триггер — это уже в каркасе runOnEndOfTurnTriggers.

import { applyPermanentBuff } from '../../buffs.js';
import { registerOnEndOfTurnTrigger } from './eot-triggers.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { summonUnitLivLife } from './summon.js';

export const CARD_ID = 'liv_laboratornaya_krysa';
const LABEL = 'Лабораторная крыса';

registerImplementedAbility(CARD_ID, 'trigger');

registerOnEndOfTurnTrigger(CARD_ID, (state, krysa) => {
  if (!krysa || !krysa.isAlive()) return;
  const ownerIdx = krysa.ownerId;
  if (ownerIdx == null) return;
  const owner = state.players[ownerIdx];
  // 1) +1/0/1 на оригинал.
  applyPermanentBuff(state, krysa, { atk: 1, armor: 0, hp: 1 }, CARD_ID, LABEL);
  // 2) Призыв копии на случайный свободный слот.
  const r = summonUnitLivLife(state, CARD_ID, ownerIdx, null);
  if (r.success) {
    state.log?.add(
      `🐀 ${LABEL} [${owner.name}]: +1/0/1 + призыв копии (линия ${r.line + 1}, слот ${r.slot + 1})`
    );
  } else {
    state.log?.add(
      `🐀 ${LABEL} [${owner.name}]: +1/0/1 (нет места для копии)`
    );
  }
});
